/* eslint-disable */
import { createVNode, render } from 'vue';
// 1. 导入组件
import Toast from './Temple.vue';
// 2. 准备一个DOM容器
const div = document.createElement('div');
div.setAttribute('class', 'toast');
document.body.appendChild(div);

let time = null
export default (text, duration = 1500) => {
    // 3. 创建虚拟dom          (组件对象， props)
    const vnode = createVNode(Toast,{text} )
    // 4. 把虚拟dom渲染到div
    render(vnode, div)
    // 5. 设置定时器清空
    clearTimeout(time)
    time = setTimeout(() => {
        render(null, div)
    }, duration)
}
